// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"src-ErrorPage-___ErrorPage-module__errorMessage___2mcqC"};